import StackedCardsComponent from '#app/components/blog/stacked-cards-layout.tsx'
import { type getLatestPosts } from '#app/utils/blog.server.ts'
import { LocalizedLink } from '#app/utils/i18n.tsx'
import { getPostImgSrc } from '#app/utils/misc.tsx'
import routes from '#routes/index.tsx'
import { type SerializeFrom } from '#types/common.ts'

export default ({
	latestPosts,
}: {
	latestPosts: SerializeFrom<Awaited<ReturnType<typeof getLatestPosts>>>
}) => {
	if (!latestPosts.length) return null

	return (
		<div className="container mb-sm grid grid-cols-12 px-sm py-md md:mb-md lg:mb-lg xl:mb-xxl 2xl:mb-xxxl">
			<LocalizedLink to={routes.public.blog.index.route({})}>
				<h2 className="col-span-full font-medium tracking-[0.2em] text-brand-dusk">
					<span className="mr-xxs">/</span>
					magazine
					<span className="ml-xxs">/</span>
				</h2>
			</LocalizedLink>

			<div className="col-start-1 col-end-13 flex flex-col justify-between gap-xxl pt-xxl text-brand-dusk md:gap-xxxl md:pt-xxxl">
				<StackedCardsComponent
					cards={latestPosts.map((post) => ({
						title: post.translations[0]?.title || '',
						description: post.translations[0]!.content || '',
						slug: post.translations[0]?.slug || '',
						image: getPostImgSrc(post.images[0]?.id!),
						link: routes.public.blog.post.route({
							slug: post.translations[0]?.slug!,
						}),
					}))}
				/>
			</div>
		</div>
	)
}
